module.exports = __webpack_public_path__ + "img/correction.1e20d590.jpg";